import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getLockerBoxesApi } from './getLockerBoxes.api'
import getLockerBoxesInitialState from './getLockerBoxes.initialState'
import { GetLockerBoxesErrorResponse, GetLockerBoxesRequestPayload } from './getLockerBoxes.types'

export const getLockerBoxes = createAsyncThunk(
  urls.admin.getLockerBoxes,
  async (payload: GetLockerBoxesRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getLockerBoxesApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getLockerBoxesSlice = createSlice({
  name: urls.admin.getLockerBoxes,
  initialState: getLockerBoxesInitialState,
  reducers: {
    resetGetLockerBoxes: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLockerBoxes.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getLockerBoxes.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getLockerBoxes.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetLockerBoxesErrorResponse
        state.success = null
      })
  }
})

export const { actions: getLockerBoxesActions, reducer: getLockerBoxesReducer } = getLockerBoxesSlice
export const { resetGetLockerBoxes } = getLockerBoxesActions
export default getLockerBoxesSlice.reducer
